import { render, staticRenderFns } from "./Welcoming.vue?vue&type=template&id=bb5c4284&scoped=true"
import script from "./Welcoming.vue?vue&type=script&lang=js"
export * from "./Welcoming.vue?vue&type=script&lang=js"
import style0 from "./Welcoming.vue?vue&type=style&index=0&id=bb5c4284&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb5c4284",
  null
  
)

export default component.exports